import React from 'react';
import { TopCarouselSlot } from '@redturtle/volto-rt-carousel/components';
import './head.less';

const Head = (props) => {
  const { data = {} } = props;
  return (
    <div className="listing-carousel-head">
      {data.pre_title && <div className="pre-title">{data.pre_title}</div>}
      <TopCarouselSlot {...props} />
      {data.description && (
        <div className="description">{data.description}</div>
      )}
    </div>
  );
};

export default Head;
